var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/icons/SocialTwitter.tsx"; // This file was auto-generated using scripts/generate-icons.js
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * Icon generated from social-twitter.svg
 */
export default function SocialTwitterIcon(props) {
  return _jsxDEV("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    "aria-hidden": "true",
    viewBox: "0 0 16 16",
    "data-component": "SocialTwitterIcon",
    ...props,
    children: _jsxDEV("g", {
      "fill-rule": "evenodd",
      children: [_jsxDEV("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 9
      }, this), _jsxDEV("path", {
        fill: "currentColor",
        d: "M15.969 3.049c-.59.259-1.22.436-1.884.516a3.3 3.3 0 0 0 1.442-1.815c-.634.37-1.336.64-2.084.79a3.28 3.28 0 0 0-5.59 2.988 9.3 9.3 0 0 1-6.76-3.418C.799 2.61.646 3.18.65 3.76c0 1.14.58 2.142 1.459 2.73a3.3 3.3 0 0 1-1.485-.41v.04a3.28 3.28 0 0 0 2.63 3.218 3.3 3.3 0 0 1-1.474.057 3.29 3.29 0 0 0 3.069 2.278A6.58 6.58 0 0 1 .78 13.076q-.39 0-.78-.044a9.33 9.33 0 0 0 5.038 1.472c6.036 0 9.332-4.997 9.332-9.323 0-.14 0-.28-.01-.42a6.6 6.6 0 0 0 1.64-1.7z",
        "clip-rule": "evenodd"
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 11,
    columnNumber: 5
  }, this);
}
//# sourceMappingURL=SocialTwitter.js.map